import { buildFeedbacksTableColumns } from '@/components/feedbacks-table/feedbacks-table-columns.columns';
import { buildFeedbacksTableHeaderSecondaryRow } from '@/components/feedbacks-table/feedbacks-table-columns.filters';
import { CreateFeedbacksTableColumnsArgs } from '@/components/feedbacks-table/feedbacks-table-columns.types';

export type { FeedbacksTableData } from '@/components/feedbacks-table/feedbacks-table-columns.types';

export const createFeedbacksTableColumns = ({
    filters,
    pickedReviews,
    isHeaderChecked,
    isSelectionSyncing,
    onHeaderCheckboxChange,
    getAnswerJob,
    onPhotoPreviewOpen,
    onAiResponseOpen,
}: CreateFeedbacksTableColumnsArgs) => {
    const columns = buildFeedbacksTableColumns({
        getAnswerJob,
        onPhotoPreviewOpen,
        onAiResponseOpen,
    });

    const headerSecondaryRow = buildFeedbacksTableHeaderSecondaryRow({
        columns,
        pickedReviews,
        filters,
        isHeaderChecked,
        isSelectionSyncing,
        onHeaderCheckboxChange,
    });

    return {
        columns,
        headerSecondaryRow,
    };
};
